(function () {
  'use strict';

  var maxCakeTextCharacters = 24;
  var cakeTextSetting = 'Please mention the text on cake here (maximum 24 characters, spaces not counted)';
  var syncScheduled = false;

  function hasCakeTextOrdered() {
    var state = document.getElementById('cr-cake-text-state');
    return Boolean(state && state.getAttribute('data-cake-text-ordered') === 'true');
  }

  function limitCakeTextInput(input) {
    var characters = Array.from(input.value);
    var limitedCharacters = [];
    var characterCount = 0;

    characters.forEach(function (character) {
      if (/\s/.test(character)) {
        limitedCharacters.push(character);
        return;
      }

      if (characterCount < maxCakeTextCharacters) {
        limitedCharacters.push(character);
        characterCount += 1;
      }
    });

    var limitedValue = limitedCharacters.join('');
    if (limitedValue !== input.value) {
      input.value = limitedValue;
    }
  }

  function removeValidationRules(selector) {
    if (typeof window.jqCR !== 'function') {
      return;
    }

    var field = window.jqCR(selector);
    if (!field.length || typeof field.rules !== 'function') {
      return;
    }

    try {
      field.rules('remove');
    } catch (error) {
      // The pickup validator may not be attached yet. A later sync will retry.
    }
  }

  function removePickupNameFields() {
    var firstName = document.getElementById('pickup-first-name');
    var lastName = document.getElementById('pickup-last-name');
    var legacyName = document.getElementById('pickup-name');
    var nameLabel = document.getElementById('pickup-name-label');

    ['#pickup-name', '#pickup-first-name', '#pickup-last-name'].forEach(removeValidationRules);

    [firstName, lastName, legacyName].forEach(function (field) {
      if (!field) {
        return;
      }

      field.required = false;
      field.disabled = true;
      field.removeAttribute('aria-required');
    });

    if (firstName && lastName) {
      var nameFieldsContainer = firstName.parentElement && firstName.parentElement.parentElement;
      if (nameFieldsContainer && nameFieldsContainer.contains(lastName)) {
        nameFieldsContainer.remove();
      }
    }

    if (legacyName) {
      legacyName.remove();
    }

    if (nameLabel) {
      nameLabel.remove();
    }
  }

  function activateCakeTextField(wrapper, input) {
    wrapper.hidden = false;
    wrapper.style.removeProperty('display');
    input.disabled = false;
    input.required = true;
    input.setAttribute('aria-required', 'true');
    input.setAttribute('data-cake-text-limit', String(maxCakeTextCharacters));

    var label = wrapper.querySelector('#extra_input_1_label, label[for="extra_input_1"]');
    if (label) {
      label.textContent = label.textContent.replace(/25/g, String(maxCakeTextCharacters));
    }

    var note = wrapper.querySelector('.cake-text-limit-note');
    if (!note) {
      note = document.createElement('p');
      note.className = 'cake-text-limit-note';
      note.style.marginTop = '0.4rem';
      note.style.fontSize = '0.9em';
      input.insertAdjacentElement('afterend', note);
    }
    note.textContent = 'Maximum 24 characters, spaces not counted.';

    if (input.getAttribute('data-cake-text-listener') !== 'true') {
      input.addEventListener('input', function () {
        limitCakeTextInput(input);
      });
      input.setAttribute('data-cake-text-listener', 'true');
    }

    limitCakeTextInput(input);
  }

  function deactivateCakeTextField(wrapper, input) {
    removeValidationRules('#extra_input_1');
    input.value = '';
    input.required = false;
    input.disabled = true;
    input.removeAttribute('aria-required');
    wrapper.hidden = true;
    wrapper.style.display = 'none';
  }

  function syncPickupFields() {
    syncScheduled = false;

    var cakeTextOrdered = hasCakeTextOrdered();
    var settings = window.storePickupSettings;

    if (settings && typeof settings === 'object') {
      settings.name = false;
      settings.person_collecting = false;
      settings.extra_input_1 = cakeTextOrdered ? cakeTextSetting : '';
    }

    removePickupNameFields();

    var wrapper = document.querySelector('.extra_input_1_wrapper');
    if (!wrapper) {
      return;
    }

    var input = wrapper.querySelector('#extra_input_1, input[type="text"], input:not([type]), textarea');
    if (!input) {
      return;
    }

    if (cakeTextOrdered) {
      activateCakeTextField(wrapper, input);
    } else {
      deactivateCakeTextField(wrapper, input);
    }
  }

  function scheduleSync() {
    if (syncScheduled) {
      return;
    }

    syncScheduled = true;
    window.requestAnimationFrame(syncPickupFields);
  }

  ['crJQActivated', 'crButtonsLoaded', 'crPickupActivated', 'storePickupActivated'].forEach(function (eventName) {
    document.addEventListener(eventName, scheduleSync);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleSync);
  } else {
    scheduleSync();
  }

  window.addEventListener('load', scheduleSync);

  var observer = new MutationObserver(scheduleSync);
  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
})();
